const _ = require('lodash');
const stringHelpers = require('../../../common/components/stringhelpers');
const atmInternalCampaignMapper = require('../../../common/components/analytics/atm-mapper-internal-campaign');
const { getModuleIndex } = require('../../../common/components/analytics/analytics-utils');

class ProductGroupCarouselController {
    constructor(productGroupService, carouselConfig, settingsByBreakpoint, searchService, productGroupCarouselService, decorateAdditionalDetails, settingsService, inMemoryStorage, atm) {
        this.$onInit = function() {
            this.productChunks = null;
            this.productGroupService = productGroupService;
            this.searchService = searchService;
            this.title = null;
            this.viewMoreLink = null;
            this.slickConfigLoaded = false;
            this.slickConfig = carouselConfig;
            this.settingsByBreakpoint = settingsByBreakpoint;
            this.settingsService = settingsService;
            this.productGroupCarouselService = productGroupCarouselService;
            this.idLabel = stringHelpers.hyphenate(this.productGroupId.replace(new RegExp("'", 'g'), ''));
            this.decorateAdditionalDetails = decorateAdditionalDetails;
            this.inMemoryStorage = inMemoryStorage;
            this.atm = atm;
        };
    }

    getParentTitleDisplay(displayTitle, isRecipes) {
        return isRecipes ? 'cocktail recs panel' : ('product group - ' + displayTitle);
    }

    loadProductGroup() {

        const _this = this;

        this.hasTitle = function () {
            return _.trim(_this.title).length > 0;
        };

        this.hasViewMoreLink = function () {
            return _.trim(_this.viewMoreLink).length > 0;
        };
        this.settingsByBreakpoint.getSettingValueByBreakpoint('OneSite', {
            largeFormat: 'LargeFormatCarouselPageSize',
            mediumFormat: 'MediumFormatCarouselPageSize',
            smallFormat: 'SmallFormatCarouselPageSize'
        })
            .then((pageSize) => {
                return this.settingsService.getSettingValue('Performance', 'EnableGroupingProductGroups')
                    .then(function (value) {
                        return { pageSize, value };
                    });
            })
            .then((settings) => {
                return this.settingsService.getSettingValue('ProductGroup', 'SortOptions')
                    .then(function (sortOptions) {
                        if (sortOptions == null || sortOptions.length === 0) sortOptions = [{ Value: 'Relevance' }];

                        return {
                            pageSize: settings.pageSize,
                            value: settings.value,
                            sortType: sortOptions[0].Value || 'Relevance'
                        };
                    });
            })
            .then((settings) => {

                //If products have been passed in through the directive
                if (this.products) {

                    angular.forEach(this.products.Items, item => {
                        this.decorateAdditionalDetails(item.Products);
                    });

                    return { items: this.products.Items };
                }

                //Otherwise make a request using the ID
                return this.productGroupService.getProducts({
                    pageNumber: 1,
                    pageSize: settings.pageSize,
                    ExcludeFacets: true,
                    ExcludeBanners: true,
                    sortType: settings.sortType,
                    showOnlyAvailable: this.customData && this.customData.showOnlyAvailable ? this.customData.showOnlyAvailable : false
                }, this.productGroupId, settings.value);
            })
            .then(bundles => {

                this.productCollection = bundles.items;

                return this.searchService.transformProductsToDefault(bundles.items, true);

            })
            .then(products => {

                this.productChunks = products;

                const obj = this.customData;
                if (obj) {
                    this.title = obj.title;
                    this.viewMoreLink = obj.viewMoreLink;
                }
                this.parentTitleDisplay = this.getParentTitleDisplay(this.title, this.isRecipes);
            })
            .then(() => {
                _this.slickConfigLoaded = true;

                //Cache the carousel data
                const data = {
                    productChunks: this.productChunks,
                    hasTitle: this.hasTitle,
                    title: this.title,
                    hasViewMoreLink: this.hasViewMoreLink,
                    viewMoreLink: this.viewMoreLink,
                    productCollection: this.productCollection,
                    productGroupId: this.productGroupId,
                    idLabel: this.idLabel
                };

                this.productGroupCarouselService.cacheProductGroupCarousel(data);

            });
    }
}

module.exports = function () {
    return {
        restrict: 'E',
        controller: ['ProductGroupService', 'carouselConfig', 'SettingsByBreakpointService', 'SearchService', 'ProductGroupCarouselService', 'DecorateAdditionalDetails', 'SettingsService', 'InMemoryStorage', 'AtmService', ProductGroupCarouselController],
        controllerAs: 'ctrl',
        bindToController: true,
        scope: {
            productGroupId: '=',
            customData: '=',
            products: '=?',
            isRecipes: '='
        },
        link(scope, $element) {
            //Check the cache to see if request is cached
            if (!scope.ctrl.productGroupCarouselService.isProductGroupCarouselCached(scope.ctrl.productGroupId)) {
                scope.ctrl.loadProductGroup();
                scope.ctrl.slickConfigLoaded = true;
            } else {
                const carousel = scope.ctrl.productGroupCarouselService.getCachedCarousel(scope.ctrl.productGroupId);

                scope.ctrl.productChunks = carousel.productChunks;
                scope.ctrl.hasTitle = carousel.hasTitle;
                scope.ctrl.title = scope.ctrl.customData.title || carousel.title;
                scope.ctrl.parentTitleDisplay = scope.ctrl.getParentTitleDisplay(scope.ctrl.title, scope.ctrl.isRecipes);
                scope.ctrl.hasViewMoreLink = carousel.hasViewMoreLink;
                scope.ctrl.viewMoreLink = carousel.viewMoreLink;
                scope.ctrl.productCollection = carousel.productCollection;
                scope.ctrl.productGroupId = carousel.productGroupId;
                scope.ctrl.idLabel = carousel.idLabel;

                scope.ctrl.slickConfigLoaded = true;
            }

            $element.ready(() => {
                trackAddToCart();
                trackPdpLinkClick();
                trackShowMeMore();
                trackAddToFavourites();
            });

            scope.$on('store:updated', function (newStore, oldStore) {
                if (oldStore !== newStore) {
                    scope.ctrl.productGroupCarouselService.invalidate();
                }
            });

            scope.$watch(function () {
                return scope.products;
            }, function (newValue, oldValue) {
                if (!angular.equals(newValue, oldValue)) {
                    scope.ctrl.loadProductGroup();
                }
            }, true);

            function trackAddToCart() {
                $element.on('click', '.productTile_addToTrolleyButton, [ui-sref^="shop.productdetails"]', (event) => {
                    const $target = $(event.currentTarget);
                    const $carousel = $target.closest('bws-product-group-carousel');
                    const carouselName = $carousel.find('.title-container h1').text();
                    const carouselItemIndex = parseInt($target.closest('.slick-slide').attr('data-slick-index'), 10);

                    if (isNaN(carouselItemIndex)) {
                        return;
                    }

                    const carouselItemPosition = carouselItemIndex + 1;
                    const moduleIndex = getModuleIndex($target);

                    if (moduleIndex === -1) {
                        return;
                    }

                    const modulePlace = moduleIndex + 1;

                    const eventData = {
                        type: 'product carousel',
                        campaignName: carouselName,
                        place: modulePlace,
                        position: carouselItemPosition
                    };
                    scope.ctrl.inMemoryStorage.setItem('addToCartEventData', eventData);
                });
            }

            function trackPdpLinkClick() {
                $element.on('click', '[ui-sref^="shop.productdetails"]', (event) => {
                    const $target = $(event.currentTarget);
                    const $carousel = $target.closest('bws-product-group-carousel');
                    const carouselName = $carousel.find('.title-container h1').text();
                    const carouselItemIndex = parseInt($target.closest('.slick-slide').attr('data-slick-index'), 10);

                    if (isNaN(carouselItemIndex)) {
                        return;
                    }

                    const carouselItemPosition = carouselItemIndex + 1;
                    const moduleIndex = getModuleIndex($target);

                    if (moduleIndex === -1) {
                        return;
                    }

                    const modulePlace = moduleIndex + 1;
                    const eventData = {
                        type: 'product carousel',
                        campaignName: carouselName,
                        place: modulePlace,
                        position: carouselItemPosition
                    };
                    scope.ctrl.atm.push(eventData, atmInternalCampaignMapper);
                    scope.ctrl.inMemoryStorage.setItem('prodViewEventData', eventData);
                });
            }

            function trackShowMeMore() {
                $element.on('click', '.title-container a', (event) => {
                    const $target = $(event.currentTarget);
                    const $carousel = $target.closest('bws-product-group-carousel');
                    const carouselName = $carousel.find('.title-container h1').text();
                    const moduleIndex = getModuleIndex($target);

                    if (moduleIndex === -1) {
                        return;
                    }

                    const modulePlace = moduleIndex + 1;

                    scope.ctrl.atm.push(
                        {
                            type: 'product carousel',
                            campaignName: carouselName,
                            place: modulePlace,
                            position: 'show me more'
                        },
                        atmInternalCampaignMapper
                    );
                });
            }

            function trackAddToFavourites() {
                $element.on('click', '.productTile_watchButton', (event) => {
                    const $target = $(event.currentTarget);
                    const $carousel = $target.closest('bws-product-group-carousel');
                    const carouselName = $carousel.find('.title-container h1').text();
                    const carouselItemIndex = parseInt($target.closest('.slick-slide').attr('data-slick-index'), 10);

                    if (isNaN(carouselItemIndex)) {
                        return;
                    }

                    const carouselItemPosition = carouselItemIndex + 1;
                    const moduleIndex = getModuleIndex($target);

                    if (moduleIndex === -1) {
                        return;
                    }

                    const modulePlace = moduleIndex + 1;

                    const eventData = {
                        type: 'product carousel',
                        campaignName: carouselName,
                        place: modulePlace,
                        position: carouselItemPosition
                    };
                    scope.ctrl.inMemoryStorage.setItem('addToFavouritesEventData', eventData);
                });
            }
        },
        template: require('./productgroup-carousel-template.html')
    };
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/productgroups/productgroup-carousel-directive.js
 **/